<template>
  <div>
    <v-row>
      <v-col cols="auto">
        <RangeDatePickerMenu
          v-model="dateRangeCmp"
          label="Period"
          showButtons
          @onOkClick="closeDatepicker"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="7">
        <h3 class="px-2 pb-2 title-black">Salary</h3>
        <v-divider></v-divider>
        <v-data-table
          dense
          :headers="salaryTableHeaders"
          :items="employeeSalary"
          :items-per-page="-1"
          hide-default-footer
          class="b-grey"
        >
          <template v-slot:[`item.Salary`]="{ item }">
            {{ item.Salary | moneyFilter }}
          </template>
            <template v-slot:[`item.Reporting`]="{ item }">
            {{ item.Reporting | moneyFilter }}
          </template>
          <template v-slot:[`item.Premium`]="{ item }">
            {{ item.Premium | moneyFilter }}
          </template>
          <template v-slot:[`item.L_And_D`]="{ item }">
            {{ item.L_And_D | moneyFilter }}
          </template>
          <template v-slot:[`item.Medical_Insurance`]="{ item }">
            {{ item.Medical_Insurance | moneyFilter }}
          </template>
          <template v-slot:[`item.Sport_Compensation`]="{ item }">
            {{ item.Sport_Compensation | moneyFilter }}
          </template>
          <template v-slot:[`item.Dividend`]="{ item }">
            {{ item.Dividend | moneyFilter }}
          </template>
          <template v-slot:[`item.Penalty`]="{ item }">
            {{ item.Penalty | moneyFilter }}
          </template>
          <template v-slot:[`item.Other_Bonuses`]="{ item }">
            {{ item.Other_Bonuses | moneyFilter }}
          </template>
          <template v-slot:[`item.Benefits`]="{ item }">
            {{ item.Benefits | moneyFilter }}
          </template>
          <template v-slot:[`item.Refund`]="{ item }">
            {{ item.Refund | moneyFilter }}
          </template>
          <template v-slot:[`item.Tax`]="{ item }">
            {{ item.Tax | moneyFilter }}
          </template>
          <template v-slot:[`item.Total`]="{ item }">
            {{ item.Total | moneyFilter}}
          </template>
          <template v-slot:[`item.Notes`]="{ item }">
            {{ item.Notes }}
          </template>
        </v-data-table>
        <div class="total-row mt-2">
          <span class="total-label">Total Accrued:</span>
          <span class="total-value">{{ totalSalary | moneyFilter }}</span>
        </div>
      </v-col>
      <v-col cols="12" md="5">
        <h3 class="px-2 pb-2 title-black">Payment</h3>
        <v-divider></v-divider>
        <v-data-table
          dense
          :headers="paymentTableHeaders"
          :items="employeePayments"
          :items-per-page="-1"
          hide-default-footer
          class="b-grey"
        >
          <template v-slot:[`item.Amount`]="{ item }">
            {{ item.Amount | moneyFilter }}
          </template>
        </v-data-table>
        <div class="total-row mt-2">
          <span class="total-label">Total Paid:</span>
          <span class="total-value">{{ totalPayment | moneyFilter }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-1">
      <v-col cols="auto" class="d-flex flex-column">
        <div class="balance-row mb-2">
          <span class="balance-label">Start Balance ({{ dateRange[0] }}):</span>
          <span class="balance-value" :class="{ 'balance-negative': startBalance < 0 }">
            {{ startBalance | moneyFilter }}
          </span>
        </div>
        <div class="balance-row">
          <span class="balance-label">End Balance ({{ dateRange[1] }}):</span>
          <span class="balance-value" :class="{ 'balance-negative': endBalance < 0 }">
            {{ endBalance | moneyFilter }}
          </span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from 'moment'
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'EmployeePayroll',
  components: {
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue')
  },
  props: {
    employee: {
      required: true
    }
  },
  data () {
    return {
      dates: [
        moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      ],
      datePickerMenu: false,
      employeePayments: [],
      employeeSalary: [],
      startBalance: 0,
      endBalance: 0,
      salaryTableHeaders: [
        {
          text: 'Salary Date',
          value: 'Salary_Date',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Total',
          value: 'Total',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Salary',
          value: 'Salary',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Reporting',
          value: 'Reporting',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'PM',
          value: 'PM',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'SBU',
          value: 'SBU',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Dividend',
          value: 'Dividend',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Premium',
          value: 'Premium',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Penalty',
          value: 'Penalty',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Benefits',
          value: 'Benefits',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Refund',
          value: 'Refund',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'L&D',
          value: 'L_And_D',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Sport Compensation',
          value: 'Sport_Compensation',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Medical Insurance',
          value: 'Medical_Insurance',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Other Bonuses',
          value: 'Other_Bonuses',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Notes',
          value: 'Notes',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Tax',
          value: 'Tax',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ],
      paymentTableHeaders: [
        {
          text: 'Payment Date',
          value: 'Payment_Date',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Name',
          value: 'Name',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Notes',
          value: 'Notes',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Amount',
          value: 'Amount',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Exchange Rate',
          value: 'Exchange_Rate',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Payment, UAH',
          value: 'Payment_UAH',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Payment Netto, UAH',
          value: 'Payment_Netto_UAH',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'From',
          value: 'From',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    dateRangeCmp: {
      get () {
        return this.dateRange
      },
      set (val) {
        this.dateRange = val
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    dateRange: {
      get () {
        return this.dates
      },
      set (value) {
        this.dates = [...value].sort((a, b) => {
          const dA = new Date(a)
          const dB = new Date(b)
          if (+dA > +dB) return 1
          if (+dA < +dB) return -1
          return 0
        })
      }
    },
    totalSalary () {
      return this.employeeSalary.reduce((sum, item) => sum + (item.Total || 0), 0)
    },
    totalPayment () {
      return this.employeePayments.reduce((sum, item) => sum + (item.Amount || 0), 0)
    }
  },
  mounted () {
    this.getPayment()
    this.getSalary()
    this.getBalance()
  },
  methods: {
    closeDatepicker () {
      this.datePickerMenu = false
      if (this.dateRange.length === 2) {
        this.getPayment()
        this.getSalary()
        this.getBalance()
      }
    },
    getPayment () {
      this.axios.get(`/api/employee_payroll/payment/${this.employee.Login}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeePayments = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getSalary () {
      this.axios.get(`/api/employee_payroll/salary/${this.employee.Login}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeeSalary = res.data.map(s => {
          s.Salary_Date = s.Salary_Date.substring(0, 10)
          s.Total = s.Salary + s.Reporting + s.Premium + s.PM + s.SBU + s.Dividend + s.Sport_Compensation +
                    s.L_And_D + s.Medical_Insurance + s.Other_Bonuses + s.Benefits + s.Refund - s.Penalty
          s.Notes = s.Notes || ''
          return s
        })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getBalance () {
      this.axios.get(`/api/employee_payroll/balance/${this.employee.Login}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        if (res.data && res.data.length > 0) {
          this.startBalance = res.data[0].Start_Balance || 0
          this.endBalance = res.data[0].End_Balance || 0
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  },
  filters: {
    moneyFilter (val) {
      return val ? '$' + Math.round(val).toLocaleString('en', { useGrouping: false, minimumFractionDigits: 2 }) : '$0.00'
    }
  }
}
</script>
<style lang="scss">
.b-grey {
  border-right: thin solid rgba(0, 0, 0, 0.12);
  border-left: thin solid rgba(0, 0, 0, 0.12);
  border-collapse: collapse;
  border-radius: 0;
}
.title-black {
  color: #000000DE
}
.balance-row {
  display: flex;
  align-items: center;
}
.balance-label {
  font-weight: 500;
  margin-right: 8px;
}
.balance-value {
  font-weight: 600;
  color: #4CAF50;
}
.balance-negative {
  color: #F44336 !important;
}
.total-row {
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.total-label {
  font-weight: 500;
  margin-right: 8px;
}
.total-value {
  font-weight: 600;
  color: #2196F3;
}
.theme--dark {
  .balance-label,
  .total-label {
    color: rgba(255, 255, 255, 0.87);
  }
  .balance-value {
    color: #69F0AE;
  }
  .balance-negative {
    color: #FF5252 !important;
  }
  .total-value {
    color: #64B5F6;
  }
  .title-black {
    color: rgba(255, 255, 255, 0.87);
  }
}
.theme--light {
  .balance-label,
  .total-label {
    color: rgba(0, 0, 0, 0.87);
  }
  .title-black {
    color: rgba(0, 0, 0, 0.87);
  }
}
</style>
